import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MibIconComponent } from '@medinbox/angular';
import { VideoStats } from '@shared/models';

/** What was generated from a case, under its title. */
@Component({
  selector: 'mai-case-stats',
  templateUrl: './case-stats.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MibIconComponent],
})
export class CaseStatsComponent {
  readonly videoStats = input.required<VideoStats>();
}
